import React, { FC, memo } from 'react';
import { OrderHistoryItem } from '~/lib/data-contract/auto-generated/customer-model';
import OrderListItem, { OrderListItemSkeleton } from './order-list-item/order-list-item.component';
// import styles from './OrdersList.module.css'

type Props = {
    orders?: OrderHistoryItem[];
    isLoading?: boolean;
    itemsPerPage: number;
    onSelect: (order: OrderHistoryItem) => void;
};

const OrdersList: FC<Props> = memo((props) => {
    const { orders = [], isLoading, itemsPerPage, onSelect } = props;

    if (isLoading) {
        return (
            <ul>
                {Array.from({ length: itemsPerPage }).map((_, index) => (
                    <OrderListItemSkeleton key={index} />
                ))}
            </ul>
        );
    }

    return (
        <ul>
            {orders.map((order, i) => (
                <OrderListItem key={`${order.purchaseId}-${i}`} order={order} onSelect={onSelect} />
            ))}
        </ul>
    );
});

OrdersList.displayName = 'OrdersList';
export default OrdersList;
